
export const ADD_SENSITIVITY_PLAN_INFO = 'ADD_SENSITIVITY_PLAN_INFO'; // 添加灵敏度方案
export const UPDATE_SENSITIVITY_PLAN_INFO = 'UPDATE_SENSITIVITY_PLAN_INFO'; // 修改灵敏度方案

export const GET_SENSITIVITY_PLAN_LIST = 'GET_SENSITIVITY_PLAN_LIST'; // 获取灵敏度方案列表
export const GET_SENSITIVITY_PLAN_INFO = 'GET_SENSITIVITY_PLAN_INFO'; // 获取灵敏度方案
